import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Task } from '../../models/taskService.model';

export interface TasksState {
  taskMap: Record<number, Task[]>;
}

const initialState: TasksState = {
  taskMap: {},
};

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    addTask: (state, action: PayloadAction<{ communityId: number; task: Task }>): void => {
      const { communityId, task } = action.payload;
      if (!state.taskMap[communityId]) {
        state.taskMap[communityId] = [];
      }
      state.taskMap[communityId].push(task);
    },

    setTasks(state, action: PayloadAction<{ communityId: number; tasks: Task[] }>): void {
      const { communityId, tasks } = action.payload;
      if (!state.taskMap[communityId]) {
        state.taskMap[communityId] = [];
      }
      state.taskMap[communityId] = tasks;
    },

    removeTask(state, action: PayloadAction<{ communityId: number; taskId: number }>): void {
      const { communityId, taskId } = action.payload;
      state.taskMap[communityId] = state.taskMap[communityId].filter(
        (task) => task.taskId !== taskId,
      );
    },

    updateTask(state, action: PayloadAction<{ communityId: number; task: Task }>): void {
      const { communityId, task } = action.payload;
      state.taskMap[communityId] = state.taskMap[communityId].map((e) =>
        e.taskId === task.taskId ? task : e,
      );
      if (!state.taskMap[communityId].find((e) => e.taskId === task.taskId))
        state.taskMap[communityId].push(task);
    },
  },
});

export const { addTask, setTasks, removeTask, updateTask } = taskSlice.actions;
const taskReducer = taskSlice.reducer;
export default taskReducer;
